import React from 'react';
import { func, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetDestErrors,
  resetDestRequest,
  setDistRequest,
  setTargetDistribute,
  _askForUnsavedChanges,
} from '../../../../actions/deActions/deDistributeActions';

const UnsavedChangesContent = ({
  confirmNavigation,
  resetRouterLocation,
  routerLeaveModal,
}) => {
  const dispatch = useDispatch();
  const destState = useSelector(state => state.deDistribute);
  const _handleNoClick = () => {
    dispatch(_askForUnsavedChanges(false));
    dispatch(setDistRequest(null, true));
    dispatch(setTargetDistribute(null, true));
    if (routerLeaveModal) {
      resetRouterLocation();
    }
  };
  const _handleYesClick = () => {
    dispatch(_askForUnsavedChanges(false));
    dispatch(resetDestRequest());
    if (destState.tempDistRequest) {
      dispatch(setTargetDistribute(destState.tempSelectedTarget));
      dispatch(setDistRequest(destState.tempDistRequest));
      dispatch(setTargetDistribute(null, true));
      dispatch(setDistRequest(null, true));
    }
    dispatch(resetDestErrors());
    if (routerLeaveModal) {
      confirmNavigation();
    }
  };
  const requestName = destState.distRequest.name;
  return (
    <div className="de__unsaved--body">
      <span>Are you sure you want to discard the changes to the</span>{' '}
      <span style={{ wordBreak: 'break-all' }}>{requestName}</span>{' '}
      <span>request?</span>
      <div className="de__unsaved--actions">
        <button
          type="button"
          onClick={_handleNoClick}
          className="de--btn de--btn--outline__primary"
        >
          No
        </button>
        <button
          type="button"
          onClick={_handleYesClick}
          className="de--btn de--btn__primary"
        >
          Yes
        </button>
      </div>
    </div>
  );
};

UnsavedChangesContent.propTypes = {
  confirmNavigation: func,
  resetRouterLocation: func,
  routerLeaveModal: bool,
};

export default UnsavedChangesContent;
